import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Don't redirect for auth endpoints - they return 401 for invalid credentials
      const isAuthEndpoint = error.config?.url?.startsWith('/auth/');
      // Only redirect if the request actually carried a token (expired/invalid session).
      // If no token was sent, the 401 is expected for protected endpoints on public pages.
      const hadToken = !!error.config?.headers?.Authorization;
      if (!isAuthEndpoint && hadToken) {
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
